import styled from 'styled-components'

export const LoadingWrapper = styled.div`
	min-height: 250px;
	display: flex;
	align-items: center;
	justify-content: center;
`
